import React, { Component } from "react";
import axios from 'axios';
/*import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
*/
import api from '../api';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from "@material-ui/core/styles";

const useStyles = theme => ({
  tableCell: {
  	padding: '3px',
	border: '1px solid #dee2e6',  	
  },
});

class History extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {history:[]}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.id
    	await this.getHistory(work_order_id)
    }

    getHistory(id){
		const token =localStorage.getItem('userToken')
		return axios
	     .get(api.work_order().history(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({history: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })

    }

	render() {
		var history = this.state.history
		const classes = this.props.classes;

		return (
			<Table style={{marginTop: '8px'}}>
		        <TableHead>
		          <TableRow>
		            <TableCell className={classes.tableCell} style={{fontWeight: '550', fontSize: '0.8rem'}} >Usuario</TableCell>
		            <TableCell className={classes.tableCell} style={{fontWeight: '550', fontSize: '0.8rem'}} >Fecha</TableCell>
		            <TableCell className={classes.tableCell} style={{fontWeight: '550', fontSize: '0.8rem'}} >Evento</TableCell>
		            <TableCell className={classes.tableCell} style={{fontWeight: '550', fontSize: '0.8rem'}} >Estado</TableCell>
		          </TableRow>
		        </TableHead>
		        <TableBody>
				{
					history.map((val, idx)=>{
						return (
							/*<Card className="mt-2" >
								  <CardContent>
								    <Typography color="primary" style={{fontSize: '0.75rem'}} >
								      	{val.user_from} - {val.created_at}
								    </Typography>
								    <Typography className="ml-2"  color="inherit" style={{fontSize: '0.70rem'}}  >
								    	Cambió de estado de <strong>{val.state_from}</strong> a <strong>{val.state_to}</strong>
								    </Typography>
								  </CardContent>
								</Card>
							*/

							<React.Fragment>
								<TableRow>
									<TableCell className={classes.tableCell}  style={{fontSize: '0.7rem'}}>
										{val.user}
									</TableCell>
									<TableCell className={classes.tableCell}  style={{fontSize: '0.7rem'}}>
										{val.date}								
									</TableCell>
									<TableCell className={classes.tableCell}  style={{fontSize: '0.7rem'}}>
										{val.event} - {val.model}
									</TableCell>
									<TableCell className={classes.tableCell}  style={{fontSize: '0.7rem'}}>
										{val.data.map((val, idx)=>{
											return (
												<div>{JSON.stringify(val)}</div>
											)
										})}
									</TableCell>
								</TableRow>
							</React.Fragment>
						)
					})
				}		        
				</TableBody>
			</Table>

		)
	}

}

export default withStyles(useStyles)(History);

